import { __rest, __assign } from 'tslib';
import { jsx, jsxs, Fragment as Fragment$1 } from '@emotion/react/jsx-runtime';
import { forwardRef, Fragment } from 'react';
import { renderProp } from '../../utils/renderProp.js';
import { Box } from '../../Box/index.js';
import { Scrollable } from '../../Scrollable/Scrollable.js';
import { useDatePicker } from '../hooks/useDatePicker.js';
import { useDatePickerDate } from '../hooks/useDatePickerDate.js';
import { useDatePickerDay } from '../hooks/useDatePickerDay.js';
import { useDatePickerYear } from '../hooks/useDatePickerYear.js';
import { useDatePickerHeading } from '../hooks/useDatePickerHeading.js';
import { useDatePickerPrevMonthButton } from '../hooks/useDatePickerPrevMonthButton.js';
import { useDatePickerNextMonthButton } from '../hooks/useDatePickerNextMonthButton.js';
import { useDatePickerModeToggleButton } from '../hooks/useDatePickerModeToggleButton.js';
import '../../hooks/useDetectInputMethod.js';
import '@reach/auto-id';
import '@emotion/react';
import 'lodash.get';
import '@compono/ui-theme';
import 'deepmerge';
import '@emotion/is-prop-valid';
import { DatePickerProvider, useDatePickerContext } from '../DatePickerContext/DatePickerContext.js';
import { DatePickerMonthTd } from '../DatePickerMonthTable/DatePickerMonthTd.js';
import { DatePickerMonthTh } from '../DatePickerMonthTable/DatePickerMonthTh.js';
import { DatePickerMonthTr } from '../DatePickerMonthTable/DatePickerMonthTr.js';
import { DatePickerMonthTable } from '../DatePickerMonthTable/DatePickerMonthTable.js';
import { DatePickerMonthThead } from '../DatePickerMonthTable/DatePickerMonthThead.js';
import { DatePickerMonthTbody } from '../DatePickerMonthTable/DatePickerMonthTbody.js';
import { DatePickerYearItem } from '../DatePickerYearList/DatePickerYearItem.js';
import { DatePickerYearList } from '../DatePickerYearList/DatePickerYearList.js';
import { DatePickerFooter } from './DatePickerFooter.js';
import { DatePickerArrowButton } from './DatePickerArrowButton.js';
import { DatePickerModeToggleButton } from './DatePickerModeToggleButton.js';
import { DatePickerHeading } from './DatePickerHeading.js';
import subYears from '../../node_modules/date-fns/esm/subYears/index.js';
import addYears from '../../node_modules/date-fns/esm/addYears/index.js';
import getMonth from '../../node_modules/date-fns/esm/getMonth/index.js';
import getYear from '../../node_modules/date-fns/esm/getYear/index.js';
import getDate from '../../node_modules/date-fns/esm/getDate/index.js';

var today = new Date();
var DpDate = function (propsArg) {
    var props = useDatePickerDate(propsArg).props;
    return jsx(DatePickerMonthTd, __assign({}, props));
};
var EmptyMonthTr = function () { return (jsx(DatePickerMonthTr, { children: jsx(DatePickerMonthTd, {}) })); };
var DpMonthBody = function (_a) {
    var month = _a.month, weeks = _a.weeks;
    var renderDate = useDatePickerContext().renderDate;
    return (jsxs(DatePickerMonthTbody, { children: [weeks.map(function (week, i) { return (jsx(DatePickerMonthTr, { children: week.map(function (date) {
                    var context = { date: date, inMonth: month };
                    return (jsx(Fragment, { children: renderProp({
                            prop: renderDate,
                            context: context,
                            fallback: jsx(DpDate, __assign({}, context)),
                        }) }, "".concat(getMonth(date), "-").concat(getDate(date))));
                }) }, i)); }), weeks.length < 6 && jsx(EmptyMonthTr, {}), weeks.length < 5 && jsx(EmptyMonthTr, {})] }));
};
var DpDay = function (propsArg) {
    var props = useDatePickerDay(propsArg).props;
    return jsx(DatePickerMonthTh, __assign({}, props));
};
var DpMonthHead = function () {
    var _a = useDatePickerContext(), dayLabels = _a.dayLabels, renderDay = _a.renderDay;
    return (jsx(DatePickerMonthThead, { children: jsx(DatePickerMonthTr, { children: dayLabels.map(function (context, i) { return (jsx(Fragment, { children: renderProp({
                    prop: renderDay,
                    context: context,
                    fallback: jsx(DpDay, __assign({}, context)),
                }) }, i)); }) }) }));
};
var DpMonth = function (_a) {
    var month = _a.month;
    var _b = useDatePickerContext(), getMonthDates = _b.getMonthDates, datePickerId = _b.datePickerId;
    var weeks = getMonthDates(month);
    return (jsxs(DatePickerMonthTable, __assign({ "aria-labelledby": "".concat(datePickerId, "-heading") }, { children: [jsx(DpMonthHead, {}), jsx(DpMonthBody, __assign({}, { month: month, weeks: weeks }))] })));
};
var DpYear = function (propsArg) {
    var props = useDatePickerYear(propsArg).props;
    return jsx(DatePickerYearItem, __assign({}, props));
};
var DpYearList = function () {
    var _a = useDatePickerContext(), years = _a.years, datePickerId = _a.datePickerId, renderYear = _a.renderYear;
    return (jsx(DatePickerYearList, __assign({ id: "".concat(datePickerId, "-year-list"), "aria-labelledby": "".concat(datePickerId, "-heading") }, { children: years.map(function (date) {
            var context = { date: date };
            return (jsx(Fragment, { children: renderProp({
                    prop: renderYear,
                    context: context,
                    fallback: jsx(DpYear, __assign({}, context)),
                }) }, getYear(date)));
        }) })));
};
var DpHeading = function (_a) {
    var children = _a.children;
    var _b = useDatePickerContext(), size = _b.size, datePickerId = _b.datePickerId;
    return (jsx(DatePickerHeading, __assign({ size: size, id: "".concat(datePickerId, "-heading") }, { children: children })));
};
var DpHeadingLabelText = function (propsArg) {
    var props = useDatePickerHeading(propsArg).props;
    return jsx(Fragment, __assign({}, props));
};
var DpHeadingLabel = function (_a) {
    var date = _a.date;
    var _b = useDatePickerContext(), renderHeading = _b.renderHeading, mode = _b.mode, locale = _b.locale;
    var context = { date: date, mode: mode, locale: locale };
    return (jsx(Fragment$1, { children: renderProp({
            prop: renderHeading,
            context: context,
            fallback: jsx(DpHeadingLabelText, __assign({}, context)),
        }) }));
};
var DpMonthHeading = function () {
    var focusMonths = useDatePickerContext().focusMonths;
    return (jsx(DpHeading, { children: focusMonths.map(function (month) { return (jsx("span", { children: jsx(DpHeadingLabel, __assign({}, { date: month })) }, getMonth(month))); }) }));
};
var DpYearHeading = function () {
    var focusDate = useDatePickerContext().focusDate;
    return (jsx(DpHeading, { children: jsx(DpHeadingLabel, __assign({}, { date: focusDate })) }));
};
var DpPrevMonthButton = function () {
    var props = useDatePickerPrevMonthButton().props;
    return jsx(DatePickerArrowButton, __assign({}, props));
};
var DpNextMonthButton = function () {
    var props = useDatePickerNextMonthButton().props;
    return jsx(DatePickerArrowButton, __assign({}, props));
};
var DpModeToggleButton = function (propsArg) {
    var props = useDatePickerModeToggleButton(propsArg).props;
    return jsx(DatePickerModeToggleButton, __assign({}, props));
};
var DpMonthHeader = function () {
    var _a = useDatePickerContext(), disableToggleMode = _a.disableToggleMode, renderPrevMonthButton = _a.renderPrevMonthButton, renderNextMonthButton = _a.renderNextMonthButton, renderModeToggleButton = _a.renderModeToggleButton;
    var modeToggleButtonContext = { children: jsx(DpMonthHeading, {}) };
    return (jsxs(Fragment$1, { children: [renderPrevMonthButton ? renderPrevMonthButton() : jsx(DpPrevMonthButton, {}), disableToggleMode ? (jsx(DpMonthHeading, {})) : (renderProp({
                prop: renderModeToggleButton,
                context: modeToggleButtonContext,
                fallback: jsx(DpModeToggleButton, __assign({}, modeToggleButtonContext)),
            })), renderNextMonthButton ? renderNextMonthButton() : jsx(DpNextMonthButton, {})] }));
};
var DpYearHeader = function () {
    var _a = useDatePickerContext(), disableToggleMode = _a.disableToggleMode, renderModeToggleButton = _a.renderModeToggleButton;
    var modeToggleButtonContext = { children: jsx(DpYearHeading, {}) };
    return disableToggleMode ? (jsx(DpYearHeading, {})) : (jsx(Fragment$1, { children: renderProp({
            prop: renderModeToggleButton,
            context: modeToggleButtonContext,
            fallback: jsx(DpModeToggleButton, __assign({}, modeToggleButtonContext)),
        }) }));
};
var DatePicker = forwardRef(function DatePicker(_a, ref) {
    var _b = _a.monthNum, monthNum = _b === void 0 ? 1 : _b, _c = _a.defaultMode, defaultMode = _c === void 0 ? "month" : _c, _d = _a.startYear, startYear = _d === void 0 ? subYears(today, 100) : _d, _e = _a.endYear, endYear = _e === void 0 ? addYears(today, 100) : _e, defaultFocusDate = _a.defaultFocusDate, initialFocusDate = _a.initialFocusDate, value = _a.value, locale = _a.locale, disabledBefore = _a.disabledBefore, disabledAfter = _a.disabledAfter, disabled = _a.disabled, readonly = _a.readonly, selectOnNavigate = _a.selectOnNavigate, disableToggleMode = _a.disableToggleMode, showRange = _a.showRange, id = _a.id, size = _a.size, _f = _a.themeKey, themeKey = _f === void 0 ? "datePicker" : _f, footer = _a.footer, _g = _a.autoFocus, autoFocus = _g === void 0 ? false : _g, focusDateRef = _a.focusDateRef, onSelect = _a.onSelect, renderHeading = _a.renderHeading, renderDate = _a.renderDate, renderDay = _a.renderDay, renderYear = _a.renderYear, renderNextMonthButton = _a.renderNextMonthButton, renderPrevMonthButton = _a.renderPrevMonthButton, renderModeToggleButton = _a.renderModeToggleButton, props = __rest(_a, ["monthNum", "defaultMode", "startYear", "endYear", "defaultFocusDate", "initialFocusDate", "value", "locale", "disabledBefore", "disabledAfter", "disabled", "readonly", "selectOnNavigate", "disableToggleMode", "showRange", "id", "size", "themeKey", "footer", "autoFocus", "focusDateRef", "onSelect", "renderHeading", "renderDate", "renderDay", "renderYear", "renderNextMonthButton", "renderPrevMonthButton", "renderModeToggleButton"]);
    var context = useDatePicker({
        monthNum: monthNum,
        defaultMode: defaultMode,
        startYear: startYear,
        endYear: endYear,
        defaultFocusDate: defaultFocusDate,
        initialFocusDate: initialFocusDate,
        value: value,
        locale: locale,
        disabledBefore: disabledBefore,
        disabledAfter: disabledAfter,
        disabled: disabled,
        readonly: readonly,
        selectOnNavigate: selectOnNavigate,
        disableToggleMode: disableToggleMode,
        showRange: showRange,
        id: id,
        size: size,
        autoFocus: autoFocus,
        focusDateRef: focusDateRef,
        onSelect: onSelect,
        renderHeading: renderHeading,
        renderDate: renderDate,
        renderDay: renderDay,
        renderYear: renderYear,
        renderNextMonthButton: renderNextMonthButton,
        renderPrevMonthButton: renderPrevMonthButton,
        renderModeToggleButton: renderModeToggleButton,
    });
    var focusMonths = context.focusMonths, mode = context.mode;
    return (jsx(DatePickerProvider, __assign({ value: context }, { children: jsxs(Box, __assign({ "data-date-picker": true, themeKey: themeKey, ref: ref }, props, { children: [jsxs(Box, __assign({ "data-date-picker-header": true }, { children: [mode === "month" && jsx(DpMonthHeader, {}), mode === "year" && jsx(DpYearHeader, {})] })), jsxs(Box, __assign({ "data-date-picker-body": true }, { children: [jsx(Box, __assign({ "data-date-picker-month-table-container": true }, { children: focusMonths.map(function (month) { return (jsx(DpMonth, { month: month }, getMonth(month))); }) })), mode === "year" && (jsx(Box, __assign({ "data-date-picker-year-list-container": true }, { children: jsx(Scrollable, __assign({ hideScrollbar: false }, { children: jsx(DpYearList, {}) })) })))] })), footer && (jsx(DatePickerFooter, { children: renderProp({ prop: footer, context: context }) }))] })) })));
});

export { DatePicker };
//# sourceMappingURL=DatePicker.js.map
